export const ShopIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.822 14.588 8.478 8H7l4.464 8.797h.718l.754-.002zM16.358 9.287l.643-1.27-1.526.003-.633 1.267z"
    ></path>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 5a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3zm3-1.8h18A1.8 1.8 0 0 1 22.8 5v14a1.8 1.8 0 0 1-1.8 1.8H3A1.8 1.8 0 0 1 1.2 19V5A1.8 1.8 0 0 1 3 3.2"
      clipRule="evenodd"
    ></path>
  </svg>
);
